module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/essentials/sorority-essentials-03-large-26255ae7d97caba85b41ba868e154431.jpg";